import qs from "qs";

export default function paramsSerializer(params) {
    return qs.stringify(params, {
        arrayFormat: "repeat",
        skipNulls: true,
    });
}
